<div *ngIf="deliveryOrderDetails">
	<div class="main-content-section">
		<div class="left-content">
			<div class="ride-overview">
				<div class="info-row">
					<span class="label">Booking ID:</span>
					<span class="value booking-id-value">
						<button type="button"
								class="booking-id-copy-button"
								aria-label="Copy Booking ID"
								matTooltip="Copy Booking ID"
								(click)="copyBookingIdToClipboard()">
							<i class="pi pi-copy"></i>
						</button>
						<span>{{deliveryOrderDetails.XpressDeliveryOrderId | textTransform:TextTransformType.Titlecase}}</span>
					</span>
				</div>
				<div class="info-row">
					<span class="label">Service:</span>
					<span class="value">{{deliveryOrderDetails.IsScanAndRide ? '[Scan and Ride]' : ''}} {{ serviceText | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="info-row">
					<span class="label">Driver:</span>
					<span class="value">{{ riderFullName | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="info-row">
					<span class="label">Status:</span>
					<span [class]="'status-badge status-' + getStatusClass(deliveryOrderDetails.StatusText)"
						  [matTooltip]="getStatusDisplayText(deliveryOrderDetails.StatusText) || 'N/A'">
						{{ getStatusDisplayText(deliveryOrderDetails.StatusText) | textTransform:TextTransformType.Titlecase }}
					</span>
				</div>
				<div class="info-row" *ngIf="deliveryOrderDetails.CompleteReason || deliveryOrderDetails.CancelReason">
					<span class="label">Reason:</span>
					<span class="value">{{ (deliveryOrderDetails.CompleteReason || deliveryOrderDetails.CancelReason) | textTransform:TextTransformType.Titlecase }}</span>
				</div>
			<div class="info-row" *ngIf="deliveryOrderDetails.AdminActionTimestamp">
				<span class="label">Admin Action<br/>Timestamp:</span>
				<span class="value">{{ deliveryOrderDetails.AdminActionTimestamp | date:'MMM dd, yyyy h:mm a' }}</span>
			</div>
			<div class="info-row" *ngIf="deliveryOrderDetails.AdminActionedBy">
				<span class="label">Actioned By:</span>
				<span class="value">{{ deliveryOrderDetails.AdminActionedBy | textTransform:TextTransformType.Titlecase }}</span>
			</div>
			</div>

			<div class="location-section">
				<div class="location-item pickup">
					<div class="location-icon">
						<mat-icon class="pickup-icon">radio_button_checked</mat-icon>
					</div>
					<div class="location-details">
						<div class="location-name">{{ deliveryOrderDetails.PickupAddress.BuildingName || '(No Place Name)' }}</div>
						<div class="location-address">{{ deliveryOrderDetails.PickupAddress.Address | textTransform:TextTransformType.Capitilized }}</div>
					</div>
				</div>

				<div class="route-line"></div>

				<div class="location-item dropoff">
					<div class="location-icon">
						<mat-icon class="dropoff-icon">place</mat-icon>
					</div>
					<div class="location-details">
						<ng-container *ngFor="let dropoff of deliveryOrderDetails.DropoffOrderPoints; let i = index;">
							<div class="location-name">{{ dropoff.BuildingName || '(No Place Name)' }}</div>
							<div class="location-address">{{ dropoff.Address | textTransform:TextTransformType.Capitilized }}</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>

		<!-- Map Container -->
		<div class="map-container">
			<div *ngIf="!showMap" class="map-placeholder-button">
				<button mat-raised-button class="load-map-button" (click)="loadMap()">
					<mat-icon>map</mat-icon>
					Load Map
				</button>
			</div>

			<div *ngIf="showMap && !mapError" class="map-placeholder" #mapContainer>

			</div>
			<div *ngIf="mapLoading && showMap && !mapError" class="map-loading-overlay">
				<mat-spinner diameter="40"></mat-spinner>
				<p>Loading map...</p>
			</div>
			<div *ngIf="mapError && showMap" class="map-error-overlay">
				<mat-icon class="error-icon">error_outline</mat-icon>
				<p>Unable to load map. Please try again.</p>
				<button mat-raised-button class="retry-map-button" (click)="retryLoadMap()">
					<mat-icon>refresh</mat-icon>
					Retry
				</button>
			</div>
		</div>
	</div>

	<div class="fare-section">
		<h4 class="section-title">Fare Breakdown</h4>
		<div class="fare-grid" *ngIf="isConnexBooking; else standardFareBreakdown">
			<div class="fare-column">
				<div class="fare-item">
					<span class="label">Total Fare:</span>
					<span class="value">{{ deliveryOrderDetails.Total | formatCurrency }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Toll Amount:</span>
					<span class="value">{{ deliveryOrderDetails.Toll | formatCurrency }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Waiting Fee:</span>
					<span class="value">{{ deliveryOrderDetails.WaitingFeeAmount | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Tip:</span>
					<span class="value">{{ deliveryOrderDetails.Tips | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item" *ngIf="isCancelledBooking">
					<span class="label">Cancellation Amount:</span>
					<span class="value">{{ deliveryOrderDetails.CancellationFeeAmount | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
			</div>
		</div>
		<ng-template #standardFareBreakdown>
		<div class="fare-grid">
			<div class="fare-column">
				<div class="fare-item">
					<span class="label">Base Fare:</span>
					<span class="value">{{ deliveryOrderDetails.BaseFare | formatCurrency }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Distance:</span>
					<span class="value">({{deliveryOrderDetails.Destination}}) : {{deliveryOrderDetails.MeteredFare | formatCurrency | textTransform:TextTransformType.Titlecase}}</span>
				</div>
				<div class="fare-item">
					<span class="label">Time:</span>
					<span class="value">({{deliveryOrderDetails.Duration}}) : {{deliveryOrderDetails.TripDurationCharge | formatCurrency | textTransform:TextTransformType.Titlecase}}</span>
				</div>
				<div class="fare-item">
					<span class="label">Surge:</span>
					<span class="value">{{deliveryOrderDetails.SurgeCharges | formatCurrency | textTransform:TextTransformType.Titlecase}}</span>
				</div>
				<div class="fare-item">
					<span class="label">Waiting Fee:</span>
					<span class="value">{{deliveryOrderDetails.WaitingFeeAmount | formatCurrency | textTransform:TextTransformType.Titlecase}}</span>
				</div>
				<div class="fare-item">
					<span class="label">Tip:</span>
					<span class="value">{{deliveryOrderDetails.Tips | formatCurrency | textTransform:TextTransformType.Titlecase}}</span>
				</div>
			</div>
			<div class="fare-column">
				<div class="fare-item">
					<span class="label">Promo:</span>
					<span class="value">{{ deliveryOrderDetails.Promo | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Special Disc. Amount:</span>
					<span class="value">{{ deliveryOrderDetails.SpecialDiscountAmount | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Special Disc. Type:</span>
					<span class="value">{{ deliveryOrderDetails.SpecialDiscountTypeText | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Cancellation Fee:</span>
					<span class="value">{{ deliveryOrderDetails.CancellationFeeAmount | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Total Paid:</span>
					<span class="value">{{ deliveryOrderDetails.Total | formatCurrency | textTransform:TextTransformType.Titlecase }}</span>
				</div>
				<div class="fare-item">
					<span class="label">Elapsed Time:</span>
					<span class="value">{{ deliveryOrderDetails.SessionTime | textTransform:TextTransformType.Titlecase }}</span>
				</div>
			</div>
		</div>
		</ng-template>
	</div>
</div>

